import styled from 'styled-components';
import {device} from '../../../../styled/device';
import {Button} from '../../../../components/Button';

export const Wrapper = styled.div`
  display: flex;
  row-gap: 20px;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const ButtonStyled = styled(Button)`
  @media (max-width: ${device.mobileM}) {
    font-size: 14px;

    & > .buttonLabel {
      line-height: normal;
      white-space: normal;
    }
  }
`;
